import React from 'react';
import { UIContest, UiContestLeaderboard } from 'types';
import ContestLeaderboardRow from './ContestLeaderboardRow';
import { useUserContext } from 'src/context/UserProvider';
import TopThreeRow from './TopThreeRow';

const ContestLeaderboardUI = ({
	leaderboard,
	userAttempt,
	userRankData,
}: {
	leaderboard: UiContestLeaderboard[];
	userAttempt?: UIContest;
	userRankData?: UiContestLeaderboard;
}) => {
	const { user } = useUserContext();
	// from-[#1F2A37] via-[#203343] to-[#111822]
	return (
		<div className="dark:bg-[#1F2A37] bg-[#FFF] rounded-[12px] px-[20px] pb-[16px] pt-[60px] border-[0.829px] border-[rgba(199,_201,_217,_0.10)] dark:border-[rgba(199,_201,_217,_0.10)]">
			<TopThreeRow topLeaderboardData={[...leaderboard].slice(0, 4)} />
			{leaderboard?.length > 3 ? (
				<div
					className="h-[7.84px] w-full mt-2 bg-gradient-to-b from-[#FFF] via-[#FAFAFC] to-[#FAFAFC] dark:from-[#1F2A37] dark:via-[#203343] dark:to-[#111822]"
					style={{ transform: 'perspective(10px) rotateX(1deg)', marginInline: 'auto', maxWidth: '99.3%' }}
				></div>
			) : null}
			<div>
				{leaderboard.slice(3, leaderboard?.length).map((data, i) => (
					<ContestLeaderboardRow key={i} userAttempt={data} isSelf={data?.user?._id === user?._id} />
				))}
				{userAttempt && userAttempt?.rank > 10 ? (
					<>
						<div className="px-[10%] bg-[#FAFAFC] dark:bg-[#18222D] flex justify-between text-[8.286px] text-[#555770] dark:text-[#FAFAFC] border-b-[0.083px] border-[#ccddff1a]">
							<span>:</span>
							<span>:</span>
						</div>

						<ContestLeaderboardRow userAttempt={userAttempt} isSelf={true} />
					</>
				) : userRankData && userRankData?.rank > 10 ? (
					<>
						<div className="px-[10%] bg-[#FAFAFC] dark:bg-[#18222D] flex justify-between text-[8.286px] text-[#555770] dark:text-[#FAFAFC] border-b-[0.083px] border-[#ccddff1a]">
							<span>:</span>
							<span>:</span>
						</div>

						<ContestLeaderboardRow userAttempt={userRankData} isSelf={true} />
					</>
				) : null}
			</div>
		</div>
	);
};

export default ContestLeaderboardUI;
